import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {HubPageService_MetadataLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/hub_page/service.grpc.lazy';
import {useRecentFullUrl} from '@aboutyou/router';
import {useFullSession} from '@aboutyou/user';
import {useTargetGroupIdentifier} from '../../../../shared-deprecated/useTargetGroupIdentifier';
import {useHubTypeFromSlug} from '../../utils/useHubTypeFromSlug';

export const useGetHubPageMeta = () => {
  const session = useFullSession();
  const targetGroup = useTargetGroupIdentifier();
  const fullUrl = useRecentFullUrl();
  const hubType = useHubTypeFromSlug();

  return useGrpcRequest(HubPageService_MetadataLazy, {
    session,
    targetGroup,
    hub: hubType,
    url: fullUrl,
    disabled: !session,
  });
};
